/**
 *
 * @name   : base.js
 * @author : Taichi Matsutaka
 *
 * Copyright (C) 2021 - 2025 Taichi Matsutaka
 *
 *
 */
(() => {


	/**
	 *
	 *
	 * Base
	 *
	 *
	 */
	/**************************************************************
	 * AnimationFrame
	**************************************************************/
	const requestAnimationFrame = window.requestAnimationFrame || window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame || window.msRequestAnimationFrame;
	const cancelAnimationFrame  = window.cancelAnimationFrame || window.mozcancelAnimationFrame || window.webkitcancelAnimationFrame || window.mscancelAnimationFrame;
	window.requestAnimationFrame = requestAnimationFrame;
	window.cancelAnimationFrame  = cancelAnimationFrame;





	/**************************************************************
	 * customEventSetting
	**************************************************************/
	const customEventSetting = () => {
		if ( typeof window.CustomEvent === "function" ) return false;

		function CustomEvent ( event, params ) {
			params = params || { bubbles: false, cancelable: false, detail: undefined };
			var evt = document.createEvent( 'CustomEvent' );
			evt.initCustomEvent( event, params.bubbles, params.cancelable, params.detail );
			return evt;
		}

		CustomEvent.prototype = window.Event.prototype;
		window.CustomEvent = CustomEvent;
	}
	customEventSetting();






	/**************************************************************
	 * telUserAgent
	**************************************************************/
	const telUserAgent = () => {
		const target       = document.querySelectorAll('[href^="tel"]:not([data-pc-href])');
		const pcHrefTarget = document.querySelectorAll('[data-pc-href]');

		if( !navigator.userAgent.match(/(iPhone|Android)/) ){
			for ( let i = 0; i < target.length; i++ ) {
				target[i].style.pointerEvents = 'none';
				target[i].addEventListener('click', (e) => {
					e.preventDefault();
				}, false);
			}

			for ( let i = 0; i < pcHrefTarget.length; i++ ) {
				const pcHref = pcHrefTarget[i].dataset.pcHref;

				if( pcHref ){
					pcHrefTarget[i].setAttribute('href', pcHref);
				}
			}
		}
	}
	telUserAgent();





	/**************************************************************
	 * imgAttribute
	**************************************************************/
	const imgAttribute = () => {
		const target = document.getElementsByTagName('img');

		for ( let i = 0; i < target.length; i++ ) {
			target[i].setAttribute('onmousedown', 'return false');   //ドラッグ無効
			target[i].setAttribute('onselectstart', 'return false'); //ドラッグ無効
			// target[i].setAttribute('oncontextmenu','return false'); //右クリック無効
		}
	}
	imgAttribute();






	/**
	 *
	 *
	 * Component
	 *
	 *
	 */
	/**************************************************************
	 * c-dashed
	**************************************************************/
	const initDashed = () => {
		/******************************************
		 * HtmlInserter
		******************************************/
		class HtmlInserter {
			constructor(selector, htmlContent) {
				this.selector    = selector;
				this.htmlContent = htmlContent;
				this.insertHtml();
			}
			insertHtml() {
				const elements = document.querySelectorAll(this.selector);
				for (let i = 0; i < elements.length; i++) {
					elements[i].insertAdjacentHTML('beforeend', this.htmlContent);
				}
			}
		}
		new HtmlInserter('.c-dashed', '<svg class="c-dashed__svg"><rect></rect></svg>');
		new HtmlInserter('.c-dashed-x', '<svg class="c-dashed__svg -x"><line></line></svg>');
		new HtmlInserter('.c-dashed-y', '<svg class="c-dashed__svg -y"><line></line></svg>');


		/******************************************
		 * getComputedBorderWidthPx
		 * border-widthを取得
		******************************************/
		const getComputedBorderWidthPx = (element) => {
			const temp = document.createElement('div');

			temp.style.position   = 'absolute';
			temp.style.visibility = 'hidden';
			temp.style.height     = 'var(--border-width)';
			element.appendChild(temp);

			const px = parseFloat(getComputedStyle(temp).height);

			element.removeChild(temp);
			return px;
		};

		/******************************************
		 * getComputedBorderRadiusPx
		 * border-radiusを取得
		******************************************/
		const getComputedBorderRadiusPx = (element) => {
			const temp = document.createElement('div');

			temp.style.position   = 'absolute';
			temp.style.visibility = 'hidden';
			temp.style.borderRadius = getComputedStyle(element).borderRadius;
			element.appendChild(temp);

			const px = parseFloat(getComputedStyle(temp).borderTopLeftRadius);

			element.removeChild(temp);
			return px;
		};


		/******************************************
		 * setDashedMax
		******************************************/
	const setDashedMax = () => {
		const targets = document.querySelectorAll('.c-dashed');
		const rects   = document.querySelectorAll('.c-dashed rect');

		const setRadius = () => {
			for  (let i = 0; i < rects.length; i++ ) {
				const width       = targets[i].offsetWidth;
				const height      = targets[i].offsetHeight;
				const strokeWidth = getComputedBorderWidthPx(targets[i]);

				const maxRadiusCenter = Math.max(0, Math.min((width - strokeWidth) / 2, (height - strokeWidth) / 2));

				const computedRadius = getComputedBorderRadiusPx(targets[i]) || 0;
				const innerRadius    = Math.max(0, computedRadius - strokeWidth / 2);

				const finalRadius = Math.min(innerRadius, maxRadiusCenter);

				rects[i].setAttribute('rx', finalRadius + 'px');
				rects[i].setAttribute('ry', finalRadius + 'px');

				targets[i].classList.add('is-init');
			}
		};

		window.addEventListener('load', setRadius);
		window.addEventListener('resize', setRadius);
	};
	setDashedMax();



		/******************************************
		 * setDashedX
		******************************************/
		const setDashedX = () => {
			const targets = document.querySelectorAll('.c-dashed-x');
			const lines   = document.querySelectorAll('.c-dashed__svg.-x line');

			for ( let i = 0; i < lines.length; i++ ){
				const width = targets[i].offsetWidth;
				lines[i].setAttribute('x1', '0');
				lines[i].setAttribute('x2', width );
			}

			const setLine = () => {
				for ( let i = 0; i < lines.length; i++ ) {
					const width       = targets[i].offsetWidth;
					const strokeWidth = getComputedBorderWidthPx(targets[i]);

					lines[i].setAttribute('x2', width );
					lines[i].setAttribute('y1', strokeWidth / 2);
					lines[i].setAttribute('y2', strokeWidth / 2);

					targets[i].classList.add('is-init');
				}
			};

			window.addEventListener('load', setLine);
			window.addEventListener('resize', setLine);
		};
		setDashedX();


		/******************************************
		 * setDashedY
		******************************************/
		const setDashedY = () => {
			const targets = document.querySelectorAll('.c-dashed-y');
			const lines   = document.querySelectorAll('.c-dashed__svg.-y line');

			for ( let i = 0; i < lines.length; i++ ){
				const height = targets[i].offsetHeight;
				lines[i].setAttribute('y1', '0');
				lines[i].setAttribute('y2', height );
			}

			const setLine = () => {
				for (let i = 0; i < lines.length; i++) {
					const height      = targets[i].offsetHeight;
					const strokeWidth = getComputedBorderWidthPx(targets[i]);

					lines[i].setAttribute('y2', height );
					lines[i].setAttribute('x1', strokeWidth / 2);
					lines[i].setAttribute('x2', strokeWidth / 2);

					targets[i].classList.add('is-init');
				}
			};

			window.addEventListener('load', setLine);
			window.addEventListener('resize', setLine);
		};
		setDashedY();


	}
	initDashed();















})();
